
import { PropTypes } from 'prop-types';
import { useState } from 'react';
import ModelButton from '../modelBtn/modelButton';
import PeopleDetail from './peopleDetail';
const PriorityCard = ({ people }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const { quote, location, designation, img } = people

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);
    return (
        <>
            <div className="w-11/12    flex flex-col justify-between  gap-2 relative cursor-pointer  group select-none "
               
            >

                <img src={img} className='w-full bg-gray-200 max-w-full min-h-full h-auto object-cover text-black italic' alt={quote} />

                <div className=" w-full h-full">
                    <div className="flex flex-col  justify-between h-full gap-3 ">
                        <h1 className=" leading-5  font-bold text-base  ">{quote}</h1>
                        {location && <p className="text-sm   2xl:text-sm">{location}</p>}
                        <p className="text-sm   2xl:text-sm">{designation}</p>
                    </div>
                </div>

            </div>
            <ModelButton modalOpen={modalOpen} close={closed}>
                <PeopleDetail people={people} />
            </ModelButton>
        </>
    )
}
PriorityCard.propTypes = {
    people: PropTypes.object
}
export default PriorityCard